<script>
import { saveAs } from 'file-saver'
import blobStream from 'blob-stream'
import { toArrayBuffer, formatDate, b64toBlob } from 'src/utils'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Grid from '../components/Shared/Grid'
import DetailsModal from '../components/Shared/DetailsModal'

export default {
  name: 'Certificates',
  components: {
    Grid
  },

  data () {
    return {
      module: this.$route.meta.module,
      filterable: true,
      advancedSearchOpen: false,
      pagination: {
        rowsNumber: 0,
        rowsPerPage: 100,
        page: 1,
        descending: true,
        sortBy: 'CERTIFICATE_ID'
      },
      columnOptions: [
        { field: 'CLASS_ID', name: 'CLASS_ID', label: 'Class ID', sortable: false, filterable: false, filter: '', type: 'string' },
        { field: (row) => row.STUDENT.STUDENT_FIRST_NAME, name: 'STUDENT_FIRST_NAME', label: 'First Name', sortable: true, filterable: true, filter: '',  type: 'string' },
        { field: (row) => row.STUDENT.STUDENT_LAST_NAME, name: 'STUDENT_LAST_NAME', label: 'Last Name', sortable: true, filterable: true, filter: '',  type: 'string' },
        { field: (row) => row.CLASS.AFFILIATE.AFFILIATE_CODE, name: 'AFFILIATE_CODE', label: 'Aff. Code', sortable: true, filterable: true, filter: '',  type: 'string' },        
        { field: (row) => row.CLASS.COURSE.COURSE_NAME, name: 'COURSE_NAME', label: 'Course Name', sortable: false, filterable: false, filter: '', type: 'string' },
        {
          field: "PRINTED_IND",
          name: "PRINTED",
          label: "Printed",
          sortable: false,
          filterable: false,
          filter: "",
          type: "string",
          align: "center"
        },
        { field: 'DATE_CREATED', name: 'STATUS', label: 'Date Issued', sortable: false, filterable: false, filter: '', type: 'date' },
        { field: 'OVERNIGHT_IND', name: 'SHIPPING', label: 'Shipping Type', sortable: false, filterable: false, filter: '', type: 'string' },
      ],
      printedIndOptions: [
        { label:'All', value:-1 },
        { label:'Printed', value:1 },
        { label:'Not Printed', value:0 },
        { label:'Printing Not Required', value:2 }
      ],
      shippingOptions: [
        { label:'All', value:-1 },
        { label:'Overnight', value:1 },
        { label:'Regular', value:0 },
      ]
    }
  },
  mounted(){
    let vm = this
    if(!vm.canPrintCertificates){
      vm.updateSelectedCertificatesMethod = false
    }

    const pdfFrame = vm.$refs.pdfFrame
    pdfFrame.onload = () => {
      try {
        pdfFrame.contentWindow.print()
      } catch (err) {
        console.log('print error:', err)
      } finally {
        URL.revokeObjectURL(pdfFrame.src)
      }
    }
  },
  computed: {
    ...mapState('certificates', {
      list: state => state.list,
      selectedCertificates: state => state.selectedCertificates,
      searchFields: s => s.searchFields,
      loadingData: s => s.loadingData,
      loadingCertificates: s => s.loadingCertificates
    }),
    ...mapGetters('certificates', [
      'certificateList'
    ]),
    canPrintCertificates(){
      let vm = this
      return (vm.currentUser().PRINT_PERMISSION && vm.$p(['AFFILIATE'])) || vm.$p(['ADMIN','MANAGER'],'or')
    },
    certsAreAllOvernight() {
      return this.selectedCertificates.every(c => c.OVERNIGHT_IND == 1)
    }
  },
  methods: {
    ...mapActions('certificates', [
      'fetch',
      'generateCertificates',
      'exportExcel',
      'print',
      'changeShippingType',
    ]),
    ...mapMutations('certificates', [
      'updateSelectedCertificates',
      'resetSearchFields'
    ]),
    search() {
      this.$root.$emit('refreshGrid:certificatesGrid')
    },
    fetchAndClear(){
      this.resetSearchFields()
      this.search()
    },
    downloadSelectedCertificates () {
      this.generateCertificates()
      .then(response => {
        saveAs(
          response.data,
          formatDate(new Date()) + ' Certificates.pdf'
        )
      })
    },
    printCertificate() {
      const vm = this
      const pdfFrame = vm.$refs.pdfFrame

      if (vm.selectedCertificates.length > 0) {
        vm.generateCertificates()
          .then(response => {
            const pdf = response.data
            pdfFrame.src = URL.createObjectURL(pdf)
            vm.print({ certificateIds: this.selectedCertificates.map(c => c.CERTIFICATE_ID) })
              .then(vm.search)
          })
      }
    },
    // Need to define the mthod here so we can delete it if not allowed to dl certs
    updateSelectedCertificatesMethod(certs){
      this.updateSelectedCertificates(certs)
    },
    changeShipping() {
      const vm = this
      if (vm.selectedCertificates.length <= 0) {
        return
      }

      const overnight_ind = this.certsAreAllOvernight ? 0 : 1
      this.changeShippingType({
        overnight_ind,
        certificateIds: vm.selectedCertificates.map(c => c.CERTIFICATE_ID)
      })
      .then(vm.search)
    },
  }
}
</script>

<template>
  <q-page class="stretch-grid has-search no-footer">
    <q-collapsible class="search-box" collapse-icon="fa fa-angle-down">
      <template slot="header" class="search-box">
        <h5 style="padding: 12px 0px 12px 13px;width: 100%;">
          <q-icon name="fa fa-users" color="primary" style="padding:0 5px 3px" />Certificate Search
        </h5>
      </template>
      <form v-on:submit.prevent="">
        <!-- All -->
        <div class="sl-row" style="padding:0 30px 5px">
          <div class="sl-col-3">
            <div class="sl-row">
              <div class="col-12">
                <q-input float-label="Affiliate Code" v-model="searchFields['CLASS.AFFILIATE.AFFILIATE_CODE']" />
              </div>
            </div>
          </div>
          <div class="sl-col-3">
            <div class="sl-row">
              <div class="col-12">
                <q-datetime
                  clearable
                  v-model="searchFields['ISSUED_START_DATE']"
                  :before="[{icon: 'calendar_today' }]"
                  @clear="search()"
                  type="date"
                  format="MM/DD/YYYY"
                  float-label="Issued Start Date"
                  popover
                />
              </div>       
            </div>
          </div>
          <div class="sl-col-3">
            <div class="sl-row">
              <div class="col-12">
                <q-datetime
                  clearable
                  v-model="searchFields['ISSUED_END_DATE']"
                  :before="[{icon: 'calendar_today' }]"
                  type="date"
                  format="MM/DD/YYYY"
                  float-label="Issued End Date"
                  popover
                  @clear="search()"
                />
              </div>        
            </div>
          </div>
          <div class="sl-col-3">
            <div class="sl-row">
              <div class="col-12">
                <q-select
                  :options="printedIndOptions"
                  v-model="searchFields.PRINTED_IND"
                  clearable
                  :clear-value="-1"
                  @clear="search()"
                  float-label="Print Status" />
              </div>
            </div>
          </div>
        </div>
        <div class="sl-row" style="padding:0 30px 5px">
          <div class="sl-col-3">
            <div class="sl-row">
              <div class="col-12">
                <q-select
                  :options="shippingOptions"
                  v-model="searchFields.OVERNIGHT_IND"
                  clearable
                  :clear-value="-1"
                  @clear="search()"
                  float-label="Shipping Type" />
              </div>
            </div>
          </div>
        </div>

        <q-toolbar color="white" style="padding-right:60px">
          <q-toolbar-title></q-toolbar-title>
          <q-btn color="secondary" label="Clear" outline size="sm" type="reset" style="margin-right:5px" @click.prevent.stop="fetchAndClear"/> 
          <q-btn color="primary" label="Search" size="sm" type="submit" @click.prevent.stop="search()" />
        </q-toolbar>
      </form>
    </q-collapsible>
    <!-- content -->
    <Grid
      class='fit'
      id="certificatesGrid"
      :loading="loadingData"
      :module="module"
      :data="certificateList"
      :columns="columnOptions"
      :onRequest="fetch"
      :onExport="fetch"
      :filterable="filterable"
      :onSelect="updateSelectedCertificatesMethod"
      :selectable="canPrintCertificates ? 'multiple' : 'none'"
      :selected="selectedCertificates"
      :pagination="pagination"
    >
      <template slot="header-left" v-if="canPrintCertificates">
        <q-btn
          icon="fa fa-download"
          size="md"
          color="green"
          outline
          :loading="loadingCertificates"
          v-if="selectedCertificates.length <= certificateList.length && selectedCertificates.length !== 0"
          @click="downloadSelectedCertificates()"
        >
          <q-tooltip anchor="bottom middle" :offset="[0, 50]">Download</q-tooltip>
          <q-spinner-puff slot="loading" />
        </q-btn>
      </template>
      <template slot="header-left" v-if="$p(['ADMIN'])">
        <q-btn
          style="margin-left: 1em;"
          icon="fa fa-print"
          size="md"
          color="purple"
          outline
          :loading="loadingCertificates"
          v-if="selectedCertificates.length <= certificateList.length && selectedCertificates.length !== 0"
          @click="printCertificate()"
        >
          <q-tooltip anchor="bottom middle" :offset="[0, 50]">Print</q-tooltip>
          <q-spinner-puff slot="loading" />
        </q-btn>
        <q-btn
          style="margin-left: 1em;"
          icon="fa fa-plane"
          size="md"
          color="primary"
          :outline="!certsAreAllOvernight"
          :loading="loadingCertificates"
          v-if="selectedCertificates.length <= certificateList.length && selectedCertificates.length !== 0"
          @click="changeShipping"
        >
          <q-tooltip
            anchor="bottom middle"
            :offset="[0, 50]"
            v-if="certsAreAllOvernight"
          >
            Mark as Regular
          </q-tooltip>
          <q-tooltip
            anchor="bottom middle"
            :offset="[0, 50]"
            v-else
          >
            Mark as Overnight
          </q-tooltip>
          <q-spinner-puff slot="loading" />
        </q-btn>
      </template>
      <template slot="header-item" slot-scope="props">
        {{props.label}}
      </template>
      <template slot="col-item-shipping" slot-scope="props">
        {{ props.value === 0 ? 'Regular' : 'Overnight' }}
      </template>
      <template slot="col-item" slot-scope="props">
        {{props.value}}
      </template>
      <template slot="col-item-printed" slot-scope="props">
        <i
          style="font-size:20px"
          class="fa"
          :class="{
                'fa-minus text-purple': props.value == 2,
                'fa-check text-green': props.value == 1,
                'fa-close text-red' : props.value == 0
              }"
        >
          <q-tooltip
            anchor="bottom middle"
            :offset="[0, 50]"
            v-if="props.value == 2"
          >
            Printing Not Required
          </q-tooltip>
        </i>
      </template>
    </Grid>
    <iframe style="display: none" ref="pdfFrame"></iframe>
  </q-page>
</template>


<style>
</style>